import styled from "styled-components";
import fipayFonts from "../../../../theme/index";
import { colors } from "../../../../theme/color";

interface StyledDivProps {
  backgroundColor?: string;
  position?: string;
}

export const BubbleOuterDiv = styled.div<StyledDivProps>`
  width: 100%;
  height: 24px;
  display: flex;
  justify-content: ${(props) => props.position};
  align-items: center;
  margin-top: 15px;
  margin-bottom: 20px;
`;

export const BubbleContainer = styled.div<StyledDivProps>`
  display: flex;
  width: 10.8rem;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 30px;

  background: ${(props) => props.backgroundColor};

  @media screen and (max-width: 767px) {
    width: 8.75rem;
  }
  @media screen and (max-width: 375px) {
    width: 156px;
  }
`;

export const SubtitleText = styled.div`
  /* text-align: left; */
  font-size: ${fipayFonts.fipayFonts.body3.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  color: ${colors.Primary};

  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.footer1.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    /* text-align: left; */
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.footer1.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    /* text-align: left; */
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.footer1.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    text-align: left;
  }
`;
